import { Text, Title } from "dash-styled"

export const InstructionsHeader = ({ title }: { title: JSX.Element }) => {
    return (
        <>
            <Title variant="heading3" noMargin>
                {title}
            </Title>
            <Text size="xs" className="m-0 mt-2 mb-3">
                We'll use it to automatically extract values on this and other
                documents
            </Text>
        </>
    )
}
